import { Environment } from "../app/shared/models/environment.model";

export const environment: Environment = {
    production: false,
    version: '1.0.0',
    firebase: {
      region: 'europe-west3',
      functionRegion: 'europe-west3',
      functionsUrl: 'https://europe-west3-eugloh-staging.cloudfunctions.net',
      apiKey: "AIzaSyC8FLm2JYmcA-qjWiVo3yDEWGC4vrEFZEQ",
      authDomain: "eugloh-staging.firebaseapp.com",
      projectId: "eugloh-staging",
      storageBucket: "eugloh-staging.appspot.com",
      messagingSenderId: "734861894561",
      appId: "1:734861894561:web:6be25d1aae92e6b528a1e0",
      measurementId: "G-GTJ65B3YLZ"
    },
    session: {
      duration: 30 * 60 * 1000,
      warningTime: 60 * 1000
    },
    recaptcha: {
      siteKey: '6LdKSz4qAAAAAMO2QbzVK4uho9I6bnABhHx9-WMs',
      v2SiteKey: '6LeFb2cqAAAAAH1ibKDn3RETwy2irunTGD8ZbjFu',
      recaptchaSecretKey: '6LdKSz4qAAAAALD-zjK1RNXRly8PQ9wRU8zj-iAW',
      apiKey: 'AIzaSyC8FLm2JYmcA-qjWiVo3yDEWGC4vrEFZEQ',
      projectId: 'eugloh-staging'
    }
};
